// This file is auto-generated.
export default {
    "version": "4.8.13",
    "buildDate": "2026-09-15 16:18:48",
    "buildPlatform": "samsung-tizen",
    "buildBrandId": "cbs-sports",
    "buildBundle": false,
    "buildEnv": "prod",
    "gql": {
        "endpoint": "https://helios-prod.cbssports.cloud"
    },
    "api": {
        "apiUrl": "https://video-api.cbssports.com/",
        "platformQuery": "samsung",
        "diffFetchInterval": 15000,
        "shortCodeInterval": 10000,
        "maxRetryFallbackMs": 600000,
        "apiKey": "zh3Z5RuTbi8VU9x1u6fJZ88x9zIi4Jed49asvVXP",
        "apiPath": "vms",
        "geoApiUrl": "https://video-api-compute.cbssports.com/v2/dma.json",
        "rotatingSegmentTitlesApiUrl": "https://video-assets.cbssports.com/events/segment-title/v1.json",
        "logoUrlBase": "https://ottimg.cbssports.com/"
    },
    "log": {
        "enabled": false,
        "minLevel": 0
    },
    "analytics": {
        "utagUrl": {
            "env": "prod",
            "platformPath": "cbssports-samsungtv"
        },
        "fields": {
            "pageNameBase": "cbssports/samsungtv/",
            "siteHierBase": "cbssports|samsungtv|"
        }
    },
    "textToSpeech": {
        "allCapsTextToSplit": [
            "CBS"
        ],
        "dotTextToIgnore": []
    },
    "contactEmail": "cbssports-samsung@cbsinteractive.com",
    "playback": {
        "idleToFullScreenMs": 8000,
        "idleToFullScreenWithActivityMs": 20000,
        "nowPlayingMsgDurationMs": 8000,
        "upNextMsgBeforeVideoEndMs": 8000,
        "ima": {
            "appName": "cbs sports",
            "bundle": "cbs sports",
            "descriptionUrl": "https://www.cbssports.com/live/",
            "url": "cbs sports",
            "appId": "cbssports.samsungtv",
            "iu": "/8264/vaw-sports/ott/cbssports_samsung_tv_app",
            "csid": "vcbs_cbssports_us_ctv_samsungtv_live"
        },
        "drm": {
            "aes": {
                "provider": "irdeto.com"
            }
        },
        "debug": false
    },
    "featureFlags": {
        "enableParamountPlus": true
    },
    "ksDeviceType": "samsung",
    "areYouStillWatching": {
        "noResponseTimeoutMs": 60000
    },
    "idleMode": {
        "idleTimeoutMs": 900000
    },
    "network": {
        "intervalDelay": 10000
    },
    "isDebug": false,
    "platformName": "samsung-tizen",
    "subdomain": "ctv-samsung",
    "fmsBundle": "cbssports.samsung",
    "privacy": {
        "organization": "cbs_sports",
        "property": "cbs_sports_samsung_tv"
    },
    "geoApiKey": "dU3mzatyq0bdZOheK8sE3h3cvLPHAdNh",
    "brand": {
        "id": "cbs-sports",
        "name": "CBS Sports",
        "appId": "com.cbssports.app.ps4",
        "hostedDomain": "cbssports.com",
        "defaultNetworkName": "CBS Sports HQ",
        "preGameDescription": "the latest sports news, highlights, and analysis",
        "eventType": "game",
        "colors": {
            "default": 16410885,
            "splashSpinner": 16316664
        }
    },
    "appId": "com.cbssports.app.ps4",
    "appName": "CBS Sports"
};
